import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import PurchaseCheckInput, { InputType } from './PurchaseCheckInput';

import css from './PurchasePaymentCard.module.scss';

interface Props extends React.ComponentProps<'input'> {
  className?: string;
  tailDigits: string;
  onChange?: (e: React.ChangeEvent) => void;
}

const PurchasePaymentCard = ({
  className,
  tailDigits,
  intl,
  onChange,
  ...attr
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchasePaymentCard, className);

  return (
    <div className={classes}>
      <PurchaseCheckInput
        {...attr}
        type={InputType.Radio}
        name="payment-creditcard"
        onChange={onChange}
      >
        {intl.formatMessage({ id: 'purchases.purchasePaymentCard.history' })}
        <span className={css.PurchasePaymentCard__Card}>
          <span className={css.PurchasePaymentCard__Mask}>•••• •••• •••• </span>
          {tailDigits}
        </span>
      </PurchaseCheckInput>
    </div>
  );
};

export default injectIntl(PurchasePaymentCard);
